import { render, staticRenderFns } from "./market_selection.vue?vue&type=template&id=471aaa83&scoped=true"
import script from "./market_selection.vue?vue&type=script&lang=js"
export * from "./market_selection.vue?vue&type=script&lang=js"
import style0 from "./market_selection.vue?vue&type=style&index=0&id=471aaa83&prod&scoped=true&lang=css"
import style1 from "./market_selection.vue?vue&type=style&index=1&id=471aaa83&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "471aaa83",
  null
  
)

export default component.exports